import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import type {
    GeoCoderRequestParams,
    GeoCoderResponse,
    GeoObject,
    GetAddressRequestParams,
    GetAddressResponse,
} from '@/shared/api/geoCoder';
import { getRequestContext } from '@/shared/lib/requestContext';
import { request } from './request';

const api = createApi({
    name: 'entities/geoCoder/api/api',
    baseQuery: createBaseQuery(request),
    endpoints: (builder) => {
        return {
            GeoCoder: builder.query<GeoObject[], GeoCoderRequestParams>({
                query: (payload) => {
                    return {
                        method: 'GET',
                        params: {
                            ...payload,
                            geocode:
                                typeof payload.geocode === 'string'
                                    ? `Россия, ${payload.geocode}`
                                    : payload.geocode.join(','),
                            format: 'json',
                            apikey: getRequestContext().yandexMapGeoCoderAPIKey,
                        },
                    };
                },
                keepUnusedDataFor: 2147483,
                transformResponse: ({ response }: GeoCoderResponse): GeoObject[] =>
                    response?.GeoObjectCollection?.featureMember?.map(({ GeoObject }) => {
                        GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted =
                            GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted.replace('Россия, ', '');

                        return GeoObject;
                    }) ?? [],
            }),

            GetAddress: builder.query<GetAddressResponse, GetAddressRequestParams>({
                query: (payload) => {
                    const geocode =
                        'text' in payload
                            ? 'Россия, ' + payload.text
                            : `${payload.coordinates.longitude},${payload.coordinates.latitude}`;

                    return {
                        method: 'GET',
                        params: {
                            format: 'json',
                            geocode,
                            apikey: getRequestContext().yandexMapGeoCoderAPIKey,
                        },
                    };
                },
                keepUnusedDataFor: 2147483,
                transformResponse: ({ response }: GeoCoderResponse): GetAddressResponse => {
                    const geoObject = response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject;

                    const locality = (geoObject?.description ?? '')
                        .split(', ')
                        .reverse()
                        .join(', ')
                        .replace('Россия, ', '');
                    const address = geoObject?.name ?? '';

                    return { locality, address };
                },
            }),
        };
    },
});

export const useGeoCoderLocations = api.useLazyGeoCoderQuery;

export const getGeoCoderAddress = api.endpoints.GetAddress.query;
